import { ULRS_TO_REMOVE_FROM_HISTORY } from "./constants";

export const isSkipableUrl = historyUrl =>
  ULRS_TO_REMOVE_FROM_HISTORY.some(url => url === historyUrl);

export const getRequestDataForNotStoredPrevScreen = currentScreen => ({
  member_id: currentScreen.formState.member_id,
  logged_in_member_id: currentScreen.formState.logged_in_member_id,
  username: currentScreen.formState.username,
  password: currentScreen.formState.password
});
